<div class="intro-container text-center md:text-left mb-10">
    <div class="intro-text-container">
        <img src="../../../../assets/aisslo-white.webp" class="w-[500px] mb-5 " alt="Logo">
        <div class="intro-text text-white text-sm font-inter">
            <p class="text-lg">Secure in a snap</p>
            <!-- <p>the majority have suffered alteration in some form, by injected humour,</p> -->
        </div>
    </div>
    <div
        class="intro-button-container flex flex-row justify-center md:justify-start font-inter font-semibold text-white text-lg mt-12">
        <button class="relative text-base h-12 w-44 mr-32 bg-[#31a1f6] text-white font-poppins overflow-hidden hover:text-blue-500 transition-colors duration-300 group">
            <span class="absolute top-0 left-0 h-full w-0 bg-white transition-all duration-300 group-hover:w-full z-0"></span>
            <span class="relative z-10">Explore</span>
        </button>
        <a
            class="relative w-44 text-white text-center cursor-pointer before:content-[''] before:absolute before:left-0 before:bottom-0 before:w-0 before:h-[2px] before:bg-blue-500 hover:before:w-full before:transition-all before:duration-300">
            Learn More
        </a>
    </div>
</div>